<template>
  <div class='my-process-list'>
        <el-tabs v-if="!isShowProcessTemplate&&!isMenuMode" type="card" v-model="tabName" :tab-position="subTabPosition" class="tabStyle" @tab-click="handleTabClick">
            <!-- 进行中 -->
            <el-tab-pane name="first" label="进行中">
                <MyProcessListView v-if="isShowMyProcessListView1" :isSearchNowTasks="isSearchNowTasks" ref="myProcessListView1" :tableHeight="tableHeight" :tableStyle="tableStyle" :key="loadTimer" :processState="processState" :taskInfo="taskInfo" :hideModeSwich="hideModeSwich" @handleModeSwitch="handleModeSwitch" @handleTemplateSwitch="handleTemplateSwitch" :isShowNewMode="isShowNewMode" :role="role" :isFromBusTab="isFromBusTab" :isListView="isListView" :isSubProcessShow="isSubProcessShow" :isProjectMainLine="isProjectMainLine" :subProcessList="subProcessList" @navToBusiniessTaskTab="navToBusiniessTaskTab" @changeMenuMode="changeMenuMode"/>
            </el-tab-pane>
            <!-- 已完成 -->
            <el-tab-pane name="second" label="已完成">
                <MyProcessListView v-if="isShowMyProcessListView2" :isSearchNowTasks="isSearchNowTasks" ref="myProcessListView2" :tableHeight="tableHeight" :tableStyle="tableStyle" :key="loadTimer" :processState="processState" :taskInfo="taskInfo" :hideModeSwich="hideModeSwich" @handleModeSwitch="handleModeSwitch" @handleTemplateSwitch="handleTemplateSwitch" :isShowNewMode="isShowNewMode" :role="role" :isFromBusTab="isFromBusTab" :isListView="isListView" :isSubProcessShow="isSubProcessShow" :isProjectMainLine="isProjectMainLine" :subProcessList="subProcessList" @navToBusiniessTaskTab="navToBusiniessTaskTab" @changeMenuMode="changeMenuMode"/>
            </el-tab-pane>
             <!-- 已终止 -->
             <el-tab-pane name="fourth" label="已终止">
                <MyProcessListView v-if="isShowMyProcessListView4" :isSearchNowTasks="isSearchNowTasks" ref="myProcessListView4" :tableHeight="tableHeight" :tableStyle="tableStyle" :key="loadTimer" :processState="processState" :taskInfo="taskInfo" :hideModeSwich="hideModeSwich" @handleModeSwitch="handleModeSwitch" @handleTemplateSwitch="handleTemplateSwitch" :isShowNewMode="isShowNewMode" :role="role" :isFromBusTab="isFromBusTab" :isListView="isListView" :isSubProcessShow="isSubProcessShow" :isProjectMainLine="isProjectMainLine" :subProcessList="subProcessList" @navToBusiniessTaskTab="navToBusiniessTaskTab" @changeMenuMode="changeMenuMode"/>
            </el-tab-pane>
            <!-- 全部的 -->
            <el-tab-pane name="third" label="全部的">
                <MyProcessListView v-if="isShowMyProcessListView3" :isSearchNowTasks="isSearchNowTasks" ref="myProcessListView3" :tableHeight="tableHeight" :tableStyle="tableStyle" :key="loadTimer" :processState="processState" :taskInfo="taskInfo" :hideModeSwich="hideModeSwich" @handleModeSwitch="handleModeSwitch" @handleTemplateSwitch="handleTemplateSwitch" :isShowNewMode="isShowNewMode" :role="role" :isFromBusTab="isFromBusTab" :isListView="isListView" :isSubProcessShow="isSubProcessShow" :isProjectMainLine="isProjectMainLine" :subProcessList="subProcessList" @navToBusiniessTaskTab="navToBusiniessTaskTab" @changeMenuMode="changeMenuMode"/>
            </el-tab-pane>
        </el-tabs>
        <ProcessTemplateMenuMode v-if="isMenuMode" ref="taskListView" class="tabStyle" @changeListMode="changeListMode"/>
  </div>
</template>
 
<script>
    import MyProcessListView from '@/pages/process/MyProcess/MyProcessListView';
    import ProcessTemplate from '@/pages/process/ProcessTemplate/ProcessTemplate';
    import { mapActions } from 'vuex';
    import * as constants from '@/common/constants';

    export default {
        components: {
            MyProcessListView,
            ProcessTemplate
        },
        data () {
            return {
                isMenuMode: false,
                tabName: 'first',
                subTabPosition: 'left',
                loadTimer: '',
                processState: 1,
                isShowMyProcessListView1: false,
                isShowMyProcessListView2: false,
                isShowMyProcessListView3: false,
                isShowMyProcessListView4: false,
                isShowProcessTemplate: false
            };
        },
        created () {
            this.isShowMyProcessListView1 = false;
            this.isShowMyProcessListView2 = false;
            this.isShowMyProcessListView3 = false;
            this.isShowMyProcessListView4 = false;
            // this._initPage();
            if (!this.isShowNewMode || this.isListView) {
                this._initPage();
            }
        },
        computed: {
        },
        watch: {
        },
        props: {
            taskInfo: {
                type: Object
            },
            tableHeight: {
                type: Number,
                default: 460
            },
            tableStyle: {
                type: String,
                default: 'width: 100%;'
            },
            hideModeSwich: {
                type: Boolean,
                default: false
            },
            isShowNewMode: {// 查询形式 false: 旧版 true：新版
                type: Boolean,
                default: false
            },
            isListView: {// 我的流程列表模式：true 块模式 false
                type: Boolean,
                default: false
            },
            role: {
                type: String,
                default: ''
            },
            isFromBusTab: {
                type: Boolean,
                default: false
            },
            isSubProcessShow: {// 是否显示子流程列表
                type: Boolean,
                default: false
            },
            isSearchNowTasks: {
                type: Boolean,
                default: false
            },
            isProjectMainLine: {
                type: Boolean,
                default: false
            },
            subProcessList: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            ...mapActions([
                constants.VUEX_ACTIONS_SIDEBAR_TOGGLE
            ]),
            handleToggleSideBar () {
                this[constants.VUEX_ACTIONS_SIDEBAR_TOGGLE]();
            },
            _initPage () {
                // 我的任务跳转过来的
                let processInstanceStr = sessionStorage.getItem('navToProcessList');
                let finish = null;// 流程完成状态,true完成，false进行中
                if (processInstanceStr) {
                    let processInstanceInfo = JSON.parse(processInstanceStr);
                    finish = processInstanceInfo.finish;
                }
                // console.log(finish);
                if (finish != null && finish) { // 已完成的任务
                    this.tabName = 'second';
                    this.processState = 2;
                    this.isShowMyProcessListView2 = true;
                    setTimeout(() => { // 调用子组件的方法
                        if (this.$refs.myProcessListView2) {
                            this.$refs.myProcessListView2._getFormData();
                        }
                    }, 0);
                } else {
                    this.tabName = 'first';
                    this.processState = 1;
                    // setTimeout(() => { // 调用子组件的方法
                    this.loadTimer = new Date().getTime();
                    this.isShowMyProcessListView1 = true;
                    setTimeout(() => {
                        if (this.$refs.myProcessListView1) {
                            this.$refs.myProcessListView1._getFormData();
                        }
                    }, 0);
                }
            },
            handleTabClick (tab, event) {
                this.loadTimer = new Date().getTime();
                this.isShowMyProcessListView1 = false;
                this.isShowMyProcessListView2 = false;
                if (tab.index === '0') { // 进行中
                    this.tabName = 'first';
                    this.processState = 1;
                    this.isShowMyProcessListView1 = true;
                    setTimeout(() => {
                        if (this.$refs.myProcessListView1) {
                            this.$refs.myProcessListView1._getFormData();
                        }
                    }, 0);
                } else if (tab.index === '1') { // 已完成
                    this.tabName = 'second';
                    this.processState = 2;
                    this.isShowMyProcessListView2 = true;
                    setTimeout(() => { // 调用子组件的方法
                        if (this.$refs.myProcessListView2) {
                            this.$refs.myProcessListView2._getFormData();
                        }
                    }, 0);
                } else if (tab.index === '2') { // 已终止
                    this.tabName = 'fourth';
                    this.processState = 4;
                    this.isShowMyProcessListView4 = true;
                    setTimeout(() => { // 调用子组件的方法
                        if (this.$refs.myProcessListView4) {
                            this.$refs.myProcessListView4._getFormData();
                        }
                    }, 0);
                } else if (tab.index === '3') { // 全部
                    this.tabName = 'third';
                    this.processState = '';
                    this.isShowMyProcessListView3 = true;
                    setTimeout(() => { // 调用子组件的方法
                        if (this.$refs.myProcessListView3) {
                            this.$refs.myProcessListView3._getFormData();
                        }
                    }, 0);
                }
            },
            handleModeSwitch (mode) {
                this.$emit('handleModeSwich', mode);
            },
            handleTemplateSwitch (flg) {
                this.isShowProcessTemplate = flg;
            },
            navToBusiniessTaskTab () {
                this.$emit('navToBusiniessTaskTab');
            },
            changeMenuMode () {
                this.isMenuMode = true;
                this.handleToggleSideBar();
            },
            changeListMode () {
                this.isMenuMode = false;
                this._initPage();
            }
        }
    };
</script>


<style lang="less">
    .my-process-list{
        width: 100%;
        .tabStyle{
            margin-top: 30px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/MyProcessListMode.vue